<script setup lang="ts">
import IconUnchecked from './IconUnchecked.vue';
import IconChecked from './IconChecked.vue';
import { computed } from 'vue';

const props = defineProps<{ modelValue?: boolean }>();
const emit = defineEmits<{
  (event: 'update:modelValue', value: boolean): void;
}>();

const icon = computed(() => (props.modelValue ? IconChecked : IconUnchecked));

function onClick() {
  emit('update:modelValue', !props.modelValue);
}
</script>

<template>
  <label class="mm-checkbox" @click="onClick">
    <component :is="icon" />

    <div v-if="$slots.default" class="mm-checkbox__label">
      <slot />
    </div>
  </label>
</template>

<style lang="stylus" scoped>
.mm-checkbox
  display grid
  grid-template-columns 24px 1fr
  align-items center
  cursor pointer
  user-select none
  gap 4px

  &[disabled=disabled]
    pointer-events none

  &__label
    padding-top .15em
</style>
